function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M7.27954 21.5547H0.334229V35.3906H7.27954V21.5547Z",
  fill: "#C5BC31"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M8.42017 21.5547V35.3906H15.3655V21.0547C13.5061 21.3984 11.5842 21.5781 9.62329 21.5781C9.22485 21.5781 8.82642 21.5703 8.42017 21.5547Z",
  fill: "#F99F49"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M16.4358 35.3906H23.3811V18.4375C21.1936 19.4922 18.8655 20.3125 16.4358 20.8437V35.3906Z",
  fill: "#55B396"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M24.4435 35.3906H31.3888V12.8906C29.3185 14.8594 26.9825 16.5469 24.4435 17.8984V35.3906Z",
  fill: "#3FA0BD"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M32.4513 11.8359V35.3906H39.3966V0.609375C37.881 4.84375 35.4982 8.65625 32.4513 11.8359Z",
  fill: "#CF4664"
});

var SvgPortfolioValueIcon = function SvgPortfolioValueIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 40,
    height: 36,
    viewBox: "0 0 40 36",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPortfolioValueIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/portfolio-value-icon.57255b87.svg";
export { ForwardRef as ReactComponent };